export const AFFILATE_LIST = 'AFFILATE_LIST';
export const MY_AFFILATE_INFO = 'MY_AFFILATE_INFO';
export const UPDATE_PAYMENT_INFO = 'UPDATE_PAYMENT_INFO';
export const ACTIVE_AFFILATE = 'ACTIVE_AFFILATE';
export const UPDATE_AFFILATE = 'UPDATE_AFFILATE';
export const CHECK_AFFILATE_EMAIL = 'CHECK_AFFILATE_EMAIL';
export const CHECK_AFFILATE_CODE = 'CHECK_AFFILATE_CODE';
export const GET_AFFILATE_INFO = 'GET_AFFILATE_INFO';

